import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Router from 'next/router';

import Radio from '../../atoms/radio';
import { getBasePath } from '../../utils/navigation';

const SortsWrapper = styled.div`
  @media screen and (min-width: ${(props) => props.theme.breakpoint.medium}) {
    overflow: hidden;
    max-height: ${(props) => (props.isOpened ? '18rem' : '0')};
    transition: ${(props) => props.theme.animation.default} max-height ${(props) => props.theme.animation.easeOutQuart};
    visibility: ${(props) => (props.isOpened ? 'visible' : 'hidden')};
  }
`;

const Sorts = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${(props) => props.theme.breakpoint.medium}) {
    max-height: 16rem;
    margin: 2rem 0;
  }
`;

const Sort = styled(Radio)`
  color: ${(props) => props.theme.color.white};

  &::before {
    border-color: ${(props) => props.theme.color.white};
  }

  &::after {
    background: ${(props) => props.theme.color.white};
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoint.medium}) {
    color: ${(props) => props.theme.color.brand};

    &::before {
      border-color: ${(props) => props.theme.color.brand};
    }

    &::after {
      background: ${(props) => props.theme.color.brand};
    }
  }
`;

const sorts = [
  {
    name: 'Best Match',
    id: 'best-match',
    value: 'score'
  },
  {
    name: 'Best Sellers',
    id: 'best-sellers',
    value: 'globalpop'
  },
  {
    name: 'Just In',
    id: 'just-in',
    value: 'date rev'
  },
  {
    name: 'Price: Low to High',
    id: 'price-asc',
    value: 'price'
  },
  {
    name: 'Price High to Low',
    id: 'price-desc',
    value: 'price rev'
  }
];

const SortList = (props) => {
  const handleOnChange = (sort) => {
    const {
      cats = null,
      trend,
      edit,
      lpc,
      brand,
      page,
      ...otherQueries
    } = Router.query;

    const base = getBasePath(props).split('?')[0];
    const as = cats ? `${base}/${cats.join('/')}` : base;

    if (Router?.query?.page) delete Router?.query?.page;

    Router.push({
      pathname: Router.pathname,
      query: { ...Router.query, isort: sort.value }
    }, {
      pathname: as,
      query: {
        ...otherQueries,
        isort: sort.value
      }
    }).then(() => {
      props.setOpened(false);
    });
  };

  return (
    <SortsWrapper isOpened={props.isOpened}>
      <Sorts>
        {
          sorts.map((sort) => (
            <Sort
              active={props.activeSort.id === sort.id}
              changed={() => handleOnChange(sort)}
              id={`${props.id}-${sort.id}`}
              key={`${sort.id}`}
              name={`sort-${sort.id}`}
              value={sort.name}
            >
              {sort.name}
            </Sort>
          ))
        }
      </Sorts>
    </SortsWrapper>
  );
};

SortList.defaultProps = {
  id: 'sort'
};

SortList.propTypes = {
  id: PropTypes.string,
  activeSort: PropTypes.object.isRequired,
  isOpened: PropTypes.bool.isRequired,
  setOpened: PropTypes.func.isRequired
};

export default SortList;
